import { useState } from 'react';
import { useEffectOnce } from './useEffectOnce';

export const useIsMounted = () => {
  const [isMounted, setIsMounted] = useState<boolean>(false);
  useEffectOnce(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  });
  return isMounted;
};
